import { useMemo } from 'react';

/**
 * 실거래(Private Terminal) 노출 여부를 판정하는 단일 진실원(single source of truth).
 *
 * 판정 순서:
 *  1) 실거래 전용 호스트(ezoptix-pro / pro.*) → 무조건 LIVE
 *  2) 백엔드 권한 플래그(canAccessLiveTrading === true) && serviceMode !== 'SIMULATION'
 *
 * 주의: 과거에 사용하던 activeSandboxMode(레거시 per-user 토글)는 더 이상 모드 판정에 사용하지 않습니다.
 * 호스트 제한 및 화이트리스트는 백엔드(functions/api/utils/serviceMode.ts)에서만 결정되며,
 * 프론트는 profile.canAccessLiveTrading / serviceMode 를 그대로 신뢰합니다.
 */
export function isLiveTradingHost(): boolean {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  return hostname.includes('ezoptix-pro') || hostname.startsWith('pro.');
}

export function resolveLiveModeFromProfile(userProfile: any): boolean {
  return (
    isLiveTradingHost() ||
    Boolean(userProfile?.canAccessLiveTrading && userProfile?.serviceMode !== 'SIMULATION')
  );
}

export function useLiveTradingMode(userProfile: any): boolean {
  return useMemo(
    () => resolveLiveModeFromProfile(userProfile),
    [userProfile?.canAccessLiveTrading, userProfile?.serviceMode]
  );
}
